import React, { useState } from "react";
import { Typography, Row, Col, Input, Alert, notification } from "antd";
import { useDispatch } from "react-redux";
import { setTriggerAnyEvent } from "../../redux/actions/globalAction";

const AddCompany = () => {
  const [companyName, setCompanyName] = useState("");
  const [companyIndustry, setCompanyIndustry] = useState("");
  const [employeeCount, setEmployeeCount] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [api, contextHolder] = notification.useNotification();

  const dispatch = useDispatch();

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Şirkət əlavə edildi!",
    });
  };

  const saveCompany = async () => {
    if (companyName && companyIndustry) {
      setButtonDisable(true);
      setShowAlert(false);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/add-company`,

        {
          method: "post",
          body: JSON.stringify({
            companyName,
            companyIndustry,
            employeeCount,
          }),
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
            "Content-Type": "application/json",
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);
        dispatch(setTriggerAnyEvent(Math.random()));
        setCompanyName("");
        setCompanyIndustry("");
        openNotificationWithIcon("success");
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {contextHolder}
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col span={8}>
          <Typography.Text className="add-title">Şirkətin adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Typography.Text className="add-title">
            Şirkət sektoru
          </Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={companyIndustry}
            onChange={(e) => setCompanyIndustry(e.target.value)}
          />
        </Col>
        <Col span={8}>
          <button
            disabled={buttonDisable}
            onClick={saveCompany}
            className="add-button"
          >
            Əlavə Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default AddCompany;
